import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {SpUiConfigService} from "../../services/sp-ui-config.service";

@customElement('sp-powered-by')
export class SpPoweredBy extends LitElement {
    @property({type: String}) version: string | number;
    static get styles() {
        // language=CSS
        return css`
            .powered-by {
                /*noinspection CssUnresolvedCustomProperty*/
                padding-top: var(--padding-top);
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }

            a {
                display: block;
                width: auto;
                height: 25px;
                cursor: pointer;
            }

            img {
                height: 100%;
            }

            span {
                color: #aaa;
                font-size: 10px;
            }
        `;
    }

    protected render() {
        return html`
            <div class="powered-by">
                <a onclick="window.open('https://www.spotteron.net', '_system', '');">
                    <img src="${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/powered-by-spotteron.png"/>
                </a>
                <span>PWA VERSION ${ this.version.toString() }</span>
            </div>
        `;
    }
}
